<template>
  <pt-customer-sample-list class="pt-customer-sample-list__withData"></pt-customer-sample-list>
</template>

<script>
import PtCustomerSampleList from './index'
export default {
  name: 'pt-customer-sample-list__withData',
  components: {
    'pt-customer-sample-list': PtCustomerSampleList
  }
}
</script>
